const LOADER_TYPES = {
    FULLSCREEN: 'FULLSCREEN',
    FULLSCREEN_TRANSPARENT: 'FULLSCREEN_TRANSPARENT',
};

export default LOADER_TYPES;
